import SEOHead from '../../components/base/SEOHead';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServiceHero from './components/ServiceHero';
import ServiceGrid from './components/ServiceGrid';
import AboutSection from './components/AboutSection';

const ServicesPage = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const schema = {
    "@context": "https://schema.org",
    "@type": "AutoRepair",
    "name": "Brooklyn Auto Body Shop",
    "telephone": "+16319337887",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Brooklyn Industrial Area",
      "addressLocality": "Brooklyn",
      "addressRegion": "NY",
      "postalCode": "11201",
      "addressCountry": "US"
    },
    "areaServed": {
      "@type": "City",
      "name": "Brooklyn",
      "containedIn": {
        "@type": "State",
        "name": "New York"
      }
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Auto Repair Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Collision Repair",
            "description": "Expert collision repair services for all vehicle types"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Paint & Body Work",
            "description": "Professional paint and body work services"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Mechanical Services",
            "description": "Complete mechanical repair and maintenance"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Insurance Claims",
            "description": "Work with all major insurance companies"
          }
        }
      ]
    }
  };

  return (
    <>
      <SEOHead
        title="Auto Repair Services Brooklyn NY - Collision, Paint & Mechanical Work"
        description="Comprehensive auto repair services in Brooklyn: collision repair, paint & body work, mechanical services, insurance claims. 30+ years experience. Free estimates. Work with all insurance companies."
        keywords="collision repair Brooklyn, auto body work NY, car paint services, mechanical repair, insurance auto repair, warranty work, accident repair Brooklyn, quality auto services"
        canonical={`${siteUrl}/services`}
        ogTitle="Auto Repair Services Brooklyn NY - Collision, Paint & Mechanical Work"
        ogDescription="Comprehensive auto repair services in Brooklyn: collision repair, paint & body work, mechanical services, insurance claims. 30+ years experience."
        geoPosition="40.6782;-73.9442"
        geoPlacename="Brooklyn, NY"
        geoRegion="US-NY"
        lastModified={new Date().toISOString()}
        schema={schema}
      />
      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar />
        <main>
          <ServiceHero />
          <ServiceGrid />
          <AboutSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default ServicesPage;
